module.exports = require("./ar-DZ.d.ts");